import { render, staticRenderFns } from "./ShiftAtomJournal.vue?vue&type=template&id=6ea76e4e&"
import script from "./ShiftAtomJournal.vue?vue&type=script&lang=ts&"
export * from "./ShiftAtomJournal.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftAtomJournal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports